import { LayoutVerifications } from '@/components/hoc';
import { BodyPage, Controls } from './components';
import { useDocumentTitle } from '@/hooks';
import { Image } from 'lucide-react';

const VerificationsPage = () => {

	useDocumentTitle({ title: 'Vérifications' });

	return (
		<LayoutVerifications
			header={{
				description: 'Vérification des photos des utilisateurs.',
				title: 'Vérifications'
			}}
			breadcrumb={{ title: 'vérifications' }}
			icon={Image}>
			<Controls />
			<BodyPage />
		</LayoutVerifications>
	);

};

export default VerificationsPage;
